module.exports = __webpack_public_path__ + "img/Light.3a3d5487.svg";